/* 
 *  Created by SGiri 02/14/2018
 */

export class ReportType {

    reportTypeId: number;
    reportType: string;

    constructor(reportTypeId: number, reportType: string) {
        this.reportTypeId = reportTypeId;
        this.reportType = reportType;
    }

    public static reportTypes: ReportType[] = [
        {
            reportTypeId: 1,
            reportType: 'Report'
        },
        {
            reportTypeId: 2,
            reportType: 'Global Prompt'
        },
        {
            reportTypeId: 3,
            reportType: 'KPI'
        },
        {
            reportTypeId: 4,
            reportType: 'Attributes'
        },
        {
            reportTypeId: 5,
            reportType: 'Scorecard'
        },

        {
            reportTypeId: 6,
            reportType: 'StandardReport'
        },

        {
            reportTypeId: 7,
            reportType: 'CompanyReport'
        },
    ];
}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/model/report-type.ts